import { useState, useEffect } from 'react';
import AuthService from '../services/AuthService';

export const useHomePageData = () => {
  const [homePageData, setHomePageData] = useState({
    blogData: [],
    testimonialsData: [],
    faqData: []
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHomePageData = async () => {
      try {
        const response = await AuthService.api.get(`/dashboard/homePageDetails`);
        const { homePageData } = response.data;
        setHomePageData(homePageData);
        setIsLoading(false);
      } catch (err) {
        setError('Failed to fetch homepage data');
        setIsLoading(false);
      }
    };

    fetchHomePageData();
  }, []);

  return { 
    blogData: homePageData.blogData || [], 
    testimonialsData: homePageData.testimonialsData || [],
    faqData: homePageData.faqsData || [],
    isLoading, 
    error 
  };
}; 